import React from "react";
import DistanceParamsContent from "../components/distanceParams/distanceParams-content";

const DistanceParams = () => {
  return <DistanceParamsContent />;
};

export default DistanceParams;
